import { signal, WritableSignal } from '@angular/core';
import { ColumnFilterDefinition } from '../../models/column-filter-definition';
import { ColumnFilterState } from '../../models/column-filter-state';
import { Observable, Subject } from 'rxjs';

export class BaseFilterState<T> {
  filterDefinition = signal<ColumnFilterDefinition | undefined>(undefined);
  isDisabled: WritableSignal<boolean> = signal(false);
  value: WritableSignal<T | undefined> = signal(undefined);
  containAsyncData$?: Observable<unknown>;
  updateFilter = new Subject<ColumnFilterState<T>>();
  selectedFilter: WritableSignal<ColumnFilterState<T>> = signal(
    new ColumnFilterState()
  );
}
